/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateCreator } from 'zustand';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { createAppStore } from '@marriott/mi-store-utils';
import { SignInDataType } from '../../molecules/SignIn/SignIn.types';

interface Tripdetails {
  tripId?: string;
  checkInDate?: string;
  checkOutDate?: string;
  propertyId?: string;
  propertyName?: string;
  orderId?: string;
  lineItemId?: string;
  orderRevisionNumber?: string;
  reservationRevisionNumber?: string;
  requestedBy?: string;
  uxlMigrationStatus?: string;
}

export interface RandData {
  firstName: string;
  lastName: string;
  tripDetails: Tripdetails;
}

export interface PropertyDttDetails {
  dtt: boolean;
  acrs: boolean;
}

interface AccountCommonState {
  randData?: RandData;
  setRandData: (data: RandData) => void;
  showReportMissingStay: boolean;
  setShowReportMissingStay: (data: boolean) => void;
  showConfirmationSuccess: boolean;
  setShowConfirmationSuccess: (date: boolean) => void;
  propertyDttDetails?: PropertyDttDetails;
  setPropertyDttDetails: (data: PropertyDttDetails) => void;
  formErrors: SignInDataType;
  setFormErrors: (errors: SignInDataType) => void;
}
const initialState: AccountCommonState = {
  randData: undefined,
  setRandData: () => {},
  showReportMissingStay: true,
  setShowReportMissingStay: () => {},
  showConfirmationSuccess: false,
  setShowConfirmationSuccess: () => {},
  propertyDttDetails: undefined,
  setPropertyDttDetails: () => {},
  formErrors: {},
  setFormErrors: () => {},
};

const accountCommonStore: StateCreator<AccountCommonState> = set => {
  return {
    ...initialState,
    setRandData: (data: RandData) => {
      set({ randData: { ...data } });
    },
    setShowReportMissingStay: (data: any) => {
      set({ showReportMissingStay: data });
    },
    setShowConfirmationSuccess: (value: boolean) => {
      set({ showConfirmationSuccess: value });
    },
    setPropertyDttDetails: (data: PropertyDttDetails) => {
      set({ propertyDttDetails: { ...data } });
    },
    setFormErrors: (errors: SignInDataType) => {
      set({ formErrors: { ...errors } });
    },
  };
};

export const useAccountCommonStore = createAppStore(accountCommonStore, {
  usePersistentStore: false,
});
